import { render, staticRenderFns } from "./ChimeVideo.vue?vue&type=template&id=60b00e52&scoped=true&"
import script from "./ChimeVideo.vue?vue&type=script&lang=js&"
export * from "./ChimeVideo.vue?vue&type=script&lang=js&"
import style0 from "./ChimeVideo.vue?vue&type=style&index=0&id=60b00e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b00e52",
  null
  
)

export default component.exports